<template>
  <div class="content self_c">
    <headNav
      color="#56AC9A"
      :back="true"
      :title="window_c['Coupon details'] + '(' + window_.index + '/' + couponData.length + ')'"
    />
    <div
      class="body self_b"
      :style="'height:' + window_.bodyH + 'px;'"
    >
      <van-swipe
        @change="onChange"
        :style="'height:' + window_.bodyH + 'px;'"
        :initial-swipe="initialSwipe"
      >
        <van-swipe-item
          class="box"
          v-for="(item, index) in couponData"
          :key="index"
        >
          <div class="item_box">
            <div
              class="item-img_"
              :style="'height:' + window_.item_h + 'px;'"
            >
              <van-image
                :style="'width:100%;height:' + window_.item_h + 'px;'"
                :src="item.imgUrl"
              >
                <template v-slot:loading>
                  <van-loading
                    type="spinner"
                    size="20"
                  />
                </template>
                <template v-slot:error>
                  <img src="../../assets/icon/default.png" />
                </template>
              </van-image>
            </div>
            <div class="self_couponTypeName">{{ item.couponTypeName }}</div>
            <div class="self_coupontime">
              {{ window_c['Validity period'] }}:
              <span>{{ getDate(item.beginDate) }}</span>
              <span>-</span>
              <span>{{ getDate(item.endDate) }}</span>
            </div>
            <div
              v-html="item.remark"
              class="item-content"
            ></div>
            <div
              class="item_left"
              :style="'top:' + window_.item_top + 'px;'"
            ></div>
            <div
              class="item_right"
              :style="'top:' + window_.item_top + 'px;'"
            ></div>
            <div
              class="qrcode_box"
              v-if="item.qrimg"
            >
              <img :src="item.qrimg" />
            </div>
          </div>
        </van-swipe-item>

        <div
          class="custom-indicator"
          slot="indicator"
        ></div>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import headNav from '@/components/headNav';
import util from '@/js/util.js';
import lang_ from '@/js/locales';
import QRCode from 'qrcode'
export default {
  data () {
    return {
      window_c: {
        'Coupon details': '優惠券詳情',
        Loading: '加載中...',
        'Validity period': '使用期限'
      },
      window_: {
        index: 1,
        bodyH: 0,
        s_h: 0,
        item_h: 0,
        item_top: 0
      },
      requestParam: {
        memberId: 0,
        brandId: 0,
        type: 0,
        pageIndex: 1,
        pageSize: 15
      },
      couponData: [],
      initialSwipe: 0
    };
  },
  created () {
    util.selfSetIcon() // 設置logo
    util.getBrand(this, () => {
      this.getMemberCoupon_();
    })
    this.initWindow();
  },
  mounted () {
    this.init_lang();
  },
  methods: {
    init_lang () {
      var window_c = this.window_c;
      window_c['Coupon details'] = lang_.t('Coupon details');
      window_c['Loading'] = lang_.t('Loading');
      window_c['Validity period'] = lang_.t('Validity period');
    },
    initWindow () {
      var type = util.getQueryParams(this.$route.params).slice(1).join('_');
      this.requestParam.type = type.split('_')[0];
      this.requestParam.pageSize = type.split('_')[1];
      this.window_.index = parseInt(type.split('_')[2]) + 1;
      this.initialSwipe = parseInt(type.split('_')[2]);
      let J = util.getWindowInner(),
        w = J.w, h = J.h;
      this.window_.bodyH = h - 46;
      var s_tab_h = this.window_.bodyH - 10;// util.GETPXBYVW_VH('vw', 10);
      this.window_.s_h = s_tab_h;
      var item_w = w - 20;//util.GETPXBYVW_VH('vw', 2.5);
      this.window_.item_h = item_w / 2;
      this.window_.item_top = item_w / 2 - 25;
      let userinfo = util.userInfo.get(this);;
      if (userinfo) {
        var userInfo = JSON.parse(userinfo);
        this.requestParam.memberId = userInfo.memberId;
        this.requestParam.brandId = util.getBrandId(this);
      }
    },
    onChange (index) {
      this.window_.index = index + 1;
    },
    getMemberCoupon_ () {
      // 從 session 中獲取數據
      let couponData = JSON.parse(sessionStorage.foodStoryCouponData)
      // 生成 二維碼
      for (let i = 0; i < couponData.length; i++) {
        let item = couponData[i];
        let content = item.memberIdCouponDes;
        if (content) {
          QRCode.toDataURL(content.toString())
            .then(url => {
              couponData[i].qrimg = url;
              //強制刷新
              this.$forceUpdate();
            })
            .catch(err => {
              couponData[i].qrimg = '';
            })
        }
      }
      this.couponData = couponData;
    },
    errorImg (img) {
      return util.errorImg(img);
    },
    getDate (e) {
      if (e == undefined || e == null || e == '') {
        return '';
      }
      if (e.split(' ')[0]) {
        return e.split(' ')[0].replace(/-/g, '/');
      }
    },
  },
  components: {
    headNav
  }
};
</script>

<style scoped lang="less">
.box {
  padding: 10px;
}

.content {
  background-color: #f5f5f5;
  padding-top: 40px;
}
.pc_content .self_b {
  padding: 0;
}

.item_box {
  /* background-color: #00a9ff; */
  position: relative;
  border-radius: 10px;
  /* margin: 2.5vw; */
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
}

.item-img_ {
  /* background-color: #16b498; */
  border-radius: 10px;
}

.item-img_ img {
  height: 100%;
  width: 100%;
  border-radius: 10px;
}

.item-content {
  /* height: 50px; */
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
}

.item_left {
  position: absolute;
  width: 50px;
  height: 50px;
  background-color: rgb(245, 245, 245);
  border-radius: 50%;
  left: -25px;
}
.item_right {
  position: absolute;
  width: 50px;
  height: 50px;
  background-color: rgb(245, 245, 245);
  border-radius: 50%;
  right: -25px;
}

.self_couponTypeName {
  padding: 5px 0;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}

.self_coupontime {
  padding: 5px 0;
  font-size: 14px;
  text-align: center;
  font-weight: 600;
}

.qrcode_box {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/coupon/coupon_detail.vue